import { Component, OnInit } from '@angular/core';
import { FiltersWorldRecordsService } from '../../services/filters-world-records.service';

@Component({
  selector: 'app-filters-world-records',
  templateUrl: './filters-world-records.component.html',
  styleUrls: ['./filters-world-records.component.scss']
})
export class FiltersWorldRecordsComponent implements OnInit {
  constructor(public filter_service: FiltersWorldRecordsService) {}

  ngOnInit() {}
}
